import { Component, inject } from "@angular/core";

import { TranslatePipe } from "@ngx-translate/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";

import { NewAppVersionDialogComponent } from "../new-app-version-dialog/new-app-version-dialog.component";

@Component({
	selector: "ic-outdated-app-version-header",
	imports: [TranslatePipe, MatDialogModule],
	templateUrl: "./outdated-app-version-header.component.html",
	styleUrls: ["./outdated-app-version-header.component.scss"],
})
export class OutdatedAppVersionHeaderComponent {
	private readonly dialog = inject(MatDialog);

	openNewAppVersionDialog() {
		this.dialog.open(NewAppVersionDialogComponent);
	}
}
